/**
 * Implements image zooming.
 */
var ImageZoom = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	function constructor() {
		jQuery( 'img.zoomable' )
			.each( this.addZoom.bind( this ) );
	};

	// Adds zoom to this element.
	p.addZoom = function( i, element ) {
		var a = jQuery( element ).wrap( '<a href="#" class="zoomable"></a>' ).parent();
		jQuery( a ).on( 'click', function( event ) {
			event.preventDefault();
			var originalImage = jQuery( event.target ).closest( 'a.zoomable' ).find( 'img' ).get( 0 );
			var img = document.createElement( 'img' );
			img.src = originalImage.src;
			img.alt = originalImage.alt;
			var $modal = jQuery(
				'<div class="modal" role="dialog">'
					+ '<div class="modal-dialog modal-image-zoom" role="document">'
					+ '<div class="modal-content">'
					+ '<div class="modal-header">'
					+ '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'
					+ '<span aria-hidden="true">&times;</span></button></div>'
					+ '<div class="modal-body">'
					+ '</div></div></div></div' );
			$modal.find( '.modal-body' ).append( img );
			$modal.on( 'hidden.bs.modal', function( e ) {
				jQuery( e.target ).remove(); } );
			$modal.modal('show');
		} );
	};

	return C;
} )();

export default ImageZoom;